<template>
  <div class="signupData">
    <span
      class="signupData_totalNum"
      v-text="item.totalNum ? `共${item.totalNum}人` : item.totalNum"
    ></span>
    <span class="progressBar_main">
      <span class="progressBarMain_bg"></span>
      <span
        class="progressBarMain_man"
        :style="{ width: `${maleBar.width}%`, left: `${maleBar.left}%` }"
      ></span>
      <span
        class="progressBarMain_woman"
        :style="{ width: `${femaleBar.width}%`, right: `${femaleBar.right}%` }"
      ></span>
      <span
        class="progressBarMain_manNum"
        :style="{ width: `${maleBar.width}%`, left: `${maleBar.left}%` }"
      >
        <span class="sex_icon el-icon-male"></span>
        <span class="sexNum" v-text="item.male"></span>
      </span>
      <span
        class="progressBarMain_womanNum"
        :style="{ width: `${femaleBar.width}%`, right: `${femaleBar.right}%` }"
      >
        <span class="sex_icon el-icon-female"></span>
        <span class="sexNum" v-text="item.female"></span>
      </span>
    </span>
    <span class="marathonList">
      <span
        class="marathonList_item"
        v-for="(item, index) in item.arr"
        :key="index"
      >
        <span class="marathonItem_num" v-text="item.num"></span>
        <span class="marathonItem_title" v-text="item.name"></span>
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'marathonSignupData',
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        title: '',
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    // item: {
    //   type: Object,
    //   default: () => {
    //     return {
    //       totalNum: 3000,
    //       male: 2000,
    //       female: 1000,
    //       arr: [
    //         {
    //           name: '全马',
    //           num: 2000,
    //         },
    //         {
    //           name: '半马',
    //           num: 600,
    //         },
    //         {
    //           name: '迷马',
    //           num: 400,
    //         },
    //       ],
    //     }
    //   },
    // },
  },
  data() {
    return {
      item: {},
    }
  },
  watch: {
    datas(val) {
      setTimeout(() => {
        this.computedData(val)
      }, 10)
    },
  },
  computed: {
    maleBar() {
      const widthPer =
        (this.item.male ? this.item.male / this.item.totalNum : 0) * 100
      return {
        width: widthPer.toFixed(2),
        left: 0,
      }
    },
    femaleBar() {
      const widthPer =
        (this.item.female ? this.item.female / this.item.totalNum : 0) * 100
      return {
        width: widthPer > 0 ? widthPer.toFixed(2) - 0 + 5 : 0,
        right: 0,
      }
    },
  },
  created() {
    console.debug(this.datas)
    this.computedData(this.datas)
  },
  methods: {
    computedData(val) {
      const data =
        val.data && val.data.dataList && val.data.dataList[0]
          ? val.data.dataList[0]
          : {
              f: 0,
              fm: 0,
              hm: 0,
              m: 0,
              mm: 0,
              total: 0,
            }
      let item = {
        totalNum: data.total,
        male: data.m,
        female: data.f,
        arr: [],
      }
      const arr = []
      if (data.fm) {
        arr.push({
          name: '全马',
          num: data.fm,
        })
      }
      if (data.hm) {
        arr.push({
          name: '半马',
          num: data.hm,
        })
      }
      if (data.mm) {
        arr.push({
          name: '迷你马',
          num: data.mm,
        })
      }
      item.arr = arr
      this.item = item
    },
  },
}
</script>

<style lang="scss" scoped>
.signupData {
  width: 100%;
  padding: 1.042vw;
  .signupData_totalNum {
    display: block;
    text-align: right;
    font-size: 1.66vw;
    line-height: 2.36vw;
    color: var(--mixtmt_greyColor3);
    font-weight: bold;
  }
  .progressBar_main {
    position: relative;
    display: block;
    margin-top: 1.042vw;
    width: 100%;
    .progressBarMain_bg {
      width: 100%;
      height: 0.694vw;
      display: block;
      background-color: var(--mixtmt_greyColor0);
      border-radius: 0.347vw;
    }
    .progressBarMain_man {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 10;
      width: 50%;
      height: 100%;
      display: block;
      background: linear-gradient(
        90deg,
        var(--mixtmt_signupData_manColor1_1),
        var(--mixtmt_signupData_manColor1_2)
      );
      border-radius: 0.347vw;
    }
    .progressBarMain_woman {
      position: absolute;
      top: 0;
      z-index: 5;
      height: 100%;
      display: block;
      background: linear-gradient(
        90deg,
        var(--mixtmt_signupData_womanColor1_1),
        var(--mixtmt_signupData_womanColor1_2)
      );
      border-radius: 0 0.347vw 0.347vw 0;
    }
    .progressBarMain_manNum,
    .progressBarMain_womanNum {
      position: absolute;
      bottom: -1.94vw;
      z-index: 10;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      .sex_icon {
        font-size: 1.11vw;
        font-weight: bold;
      }
      .sexNum {
        font-size: 0.972vw;
        padding-left: 0.208vw;
      }
    }
    .progressBarMain_manNum {
      color: var(--mixtmt_signupData_manColor1_1);
    }
    .progressBarMain_womanNum {
      color: var(--mixtmt_signupData_womanColor1_2);
    }
  }
  .marathonList {
    padding-top: 5vw;
    display: flex;
    display: -webkit-flex;
    justify-content: space-evenly;
    align-items: center;
    width: 100%;
    height: auto;
    .marathonList_item {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 5.556vw;
      height: auto;
      .marathonItem_num {
        padding-bottom: 0.694vw;
        font-size: 2.083vw;
        font-weight: bold;
      }
      .marathonItem_title {
        width: 5.556vw;
        height: 3.125vw;
        font-size: 1.11vw;
        line-height: 3.125vw;
        text-align: center;
        width: 100%;
        color: #fff;
        background: linear-gradient(180deg, #94be21 0%, #5aac62 100%);
        border-radius: 0.347vw;
      }
    }
  }
}
</style>
